export enum EnrollmentRegion {
    NA = 'NA',
    NA_Legacy = 'NA_Legacy',
    EU = 'EU'
}
